<template>
  <div class="relative" ref="wrapper">
    <div
      @click="showBlinkerTip"
      v-if="!blinkers.readConfigDashboardTip"
      class="absolute flex h-4 w-4 blinker z-40 cursor-pointer"
    >
      <span
        class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-50 blinker-color"
      ></span>
      <span
        class="relative inline-flex rounded-full h-full w-full blinker-color"
      ></span>
    </div>
    <div
      class="absolute blinker-details p-4 z-10"
      v-if="showConfigIconTip"
      ref="blinkerTip"
    >
      <h5 class="text-left">
        Configure your dashboard by adding or removing Gadgets
      </h5>
      <h5 class="font-semibold text-black my-2 text-left">
        “Who doesn’t love gadgets”
      </h5>
      <h5 class="text-left">
        Gadgets are mini views of the various apps to give a quick status of
        your progress.
      </h5>

      <vs-button
        class="mt-2 float-right text-black font-semibold"
        @click="readConfigTip"
        >Got It</vs-button
      >
    </div>

    <vs-tooltip text="Config Dashboard" position="bottom">
      <div class="mr-2 icon-container p-2" @click="configUserDashboard">
        <img
          src="@/assets/images/icons/app-marketplace/config-icon.svg"
          alt="Config Dashboard"
          class="cursor-pointer w-full"
        />
      </div>
    </vs-tooltip>
  </div>
</template>

<script>
export default {
  name: "ConfigDashBoard",
  data() {
    return {
      showConfigIconTip: false,
    };
  },
  computed: {
    blinkers() {
      return this.$store.state.dashboard.blinkers;
    },
  },
  methods: {
    handleClickOutside(event) {
      const popup = this.$refs.blinkerTip;
      const wrapper = this.$refs.wrapper;

      if (!popup.contains(event.target) && !wrapper.contains(event.target)) {
        this.showConfigIconTip = false;
        window.removeEventListener("click", this.handleClickOutside);
      }
    },
    showBlinkerTip() {
      this.showConfigIconTip = true;
      window.addEventListener("click", this.handleClickOutside);
    },
    readConfigTip() {
      this.showConfigIconTip = false;
      this.$store.commit("dashboard/UPDATE_DASHBOARD_BLINKERS", {
        status: true,
        key: "readConfigDashboardTip",
      });
    },
    configUserDashboard() {
      this.$store.commit("dashboard/SET_CONFIG_DASHBOARD", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-container {
  border-radius: 50%;
  width: 38px;
  height: 38px;
}
.blinker {
  top: 1.75em;
  right: 0.5rem;
  &-color {
    background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
  }
  &-details {
    background: #fae0a0;
    top: 3em;
    width: 25em;
    border-radius: 8px;
  }
}
</style>
